import Config from '../../config/app.config';
import { ServiceNowAdapterEvent } from '../enums';

export function gotoSNAuthorizePage(snOrigin: string, clientId: string) {
    const url = `${snOrigin}oauth_auth.do?response_type=code&redirect_uri=${Config.adapterUrl}&client_id=${clientId}&state=active`;
    window.rcServiceNowAdapter?.emit(ServiceNowAdapterEvent.HIDE_RCX_IFRAME);
    window.location.href = url;
}